export default __webpack_public_path__ + "static/media/b4.56f4374a.jpg";